module.exports = __webpack_public_path__ + "img/arrow_left_new.230fbbd2.png";